<template>
  <TagsList type="custom_notifications"
            class="mt-0">
    {{ $t('tags_for_custom_notifications') }}
  </TagsList>
</template>

<script setup>
import TagsList from "@/components/parts/crm/TagsList.vue"
</script>
